/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
const _require = require('@truqc/content-path'),
  getContentValue = _require.getContentValue;
const _require2 = require('./shared/dateDiff'),
  dateDiffInSeconds = _require2.dateDiffInSeconds;

/**
  * @function evalute - evaluate writeCurrentLocationBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const absolutePath = source.absolutePath;
  const addedIdentifier = transientContext.addedIdentifier;
  const collection = getContentValue(absolutePath, content);
  const collectionIDs = Object.keys(collection);
  let lastCollectionCreated = '1900-01-03T12:00:00.000Z';
  let lastCollectionID;
  collectionIDs.forEach(id => {
    const activity = collection[id];
    if (id !== addedIdentifier && dateDiffInSeconds(activity._created, lastCollectionCreated) > 0) {
      lastCollectionCreated = activity._created;
      lastCollectionID = id;
    }
  });
  if (collectionIDs.length === 1) {
    // set initial start time for the first activity to 12am
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    collection[addedIdentifier].startTime = now.toISOString();
  } else {
    // Goal - we want the start time to equal the previous stop time (if it exists)
    const formattedNow = await sourceEvaluator({
      type: 'currentDateBehavior'
    });
    collection[addedIdentifier].startTime = collection[lastCollectionID].stopTime || formattedNow;
    const duration = dateDiffInSeconds(collection[lastCollectionID].stopTime, collection[lastCollectionID].startTime);
    // change to hours.
    collection[lastCollectionID].duration = duration / 3600;
  }
  const writeSource = {
    type: 'writeContentBehavior',
    targetContentPath: absolutePath,
    source: collection
  };
  await sourceEvaluator(writeSource);
};
module.exports = {
  evaluate
};